import { useRouter } from 'next/router'

export default function useRedirectUrl() {
  const router = useRouter()
  const redirectUrl = Array.isArray(router.query.redirecturl)
    ? router.query.redirecturl[0]
    : router.query.redirecturl
  return redirectUrl ?? '/'
}
